import { NavigationGuard } from 'vue-router';

import { ACCOUNT_NAMESPACE } from '../../../store/modules/account';
import { store } from '../../../store';
import { RouteName } from '../../../routes/routes.constants';
import { config } from '../../config';
import { objectValueOrDefault } from '../../../util';
import { ipCountryQuery } from '@gig/magic-common';
/**
 * The signup step guard
 * - redirects to bankId signup
 * - validates the current signup step and makes
 * sure that the step being accessed is valid for the current registration
 * type and state
 * @param _to Route being navigated to
 * @param from Route where navigating from
 * @param next Function required for moving forward to the next route
 */
export const regilyGuard: NavigationGuard = async (_to, from, next) => {
    const currentIpCountry = await ipCountryQuery();

    if (
        objectValueOrDefault(
            config.signup.regilyEnabledCountries,
            currentIpCountry,
        )
    ) {
        await import(
            /* webpackChunkName: "account" */
            '@gig/magic-account'
        );
        store.dispatch(`${ACCOUNT_NAMESPACE}/setRegilyOpenState`, true);
        if (from.name) {
            next(false);
            return;
        }

        // if the user lands on sign-up
        // this avoid having a broken page below regily
        next({ replace: true, name: RouteName.HOME });
        return;
    }

    next();
};
